import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'infoMessage',
    label: i18n('entities.recyclingMaterials.fields.infoMessage'),
    schema: schemas.string(
      i18n('entities.recyclingMaterials.fields.infoMessage'),
      {},
    ),
  },
  {
    name: 'name',
    label: i18n('entities.recyclingMaterials.fields.name'),
    schema: schemas.string(
      i18n('entities.recyclingMaterials.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'containerParts',
    label: i18n('entities.recyclingMaterials.fields.containerParts'),
    schema: schemas.stringArray(
      i18n('entities.recyclingMaterials.fields.containerParts'),
      {},
    ),
  },
];